module.exports = __webpack_public_path__ + "img/ico_circle.5acf7ec9.svg";